<div class="main-container">
  <div class="terms-header">
    <h1>Terms of Use</h1>
  </div>
  <div [innerHtml]="termsOfUse.contentHtml" 
    class="terms-container" #termsContainer
    (scroll)="onScroll($event)"></div>
  <div class="terms-button">
    <button mat-raised-button [disabled]="!isEnabled" (click)="updateUserTermsAcceptance()" #agreeButton>I AGREE</button>
  </div>
</div>
